//region :: Imports ::
import {MNullable} from '../Utils';

//endregion

/** */
export type MValidationErrors = { [key: string]: string[] };

/** */
class MNSwagResult {

    public readonly exception: MNullable<any>;
    public readonly validationErrors: MNullable<MValidationErrors>;
    public readonly failed: boolean;
    public readonly hasValidationErrors: boolean;

    /** */
    private constructor(exception: MNullable<any>) {

        this.exception = exception;
        this.validationErrors = MNSwagResult.getValidationErrors(exception);
        this.failed = this.exception !== null;
        this.hasValidationErrors = this.validationErrors !== null;

    }

    /** */
    public static getValidationErrors(exception: MNullable<any>): MNullable<MValidationErrors> {

        return exception !== null &&
               exception.status === 400 &&
               exception.response.errors !== undefined &&
               exception.response.title !== undefined ? exception.response.errors : null;

    };

    /** */
    public static ok(): MNSwagResult {
        return new MNSwagResult(null);
    }

    /** */
    public static notOk(exception: any): MNSwagResult {
        return new MNSwagResult(exception);
    }

    /** */
    public throwIfFailed(): void {

        if(this.failed) {
            throw this.exception;
        }

    }

}

export default MNSwagResult;
